export default __webpack_public_path__ + "static/media/GHSI AFS 2025.4a9ff421.pdf";